import { Controller } from "@hotwired/stimulus"
import Typewriter from 'typewriter-effect/dist/core'

export default class extends Controller {

  static values = { config: Object }

  connect() {
    let options = {}
    if (this.configValue.options) { options = { ...options, ...this.configValue.options} }
    this.tt = new Typewriter(this.element, options)
    if (this.configValue.commands) {
      this.configValue.commands.forEach(item => { this.tt[item.command](item.arg) })
    }
    this.tt.start()
  }

}
